import helperFunctions from "./helper-functions";
import meetingResolutionModel from "@/store/orm-axios/models/MeetingResolution";
import resolutionVoteModel from "@/store/orm-axios/models/ResolutionVote";
let eventSource;

const meetingResolutionIRI = "/meeting_resolutions/";
const resolutionVoteIRI = "/resolution_votes/";

export default {
  computed: {
    mercureJwtToken() {
      return this.$store.getters["auth/mercureJwtToken"];
    },
  },
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initMeetingResolutionMercure();
      }
    },
  },
  mounted() {
    this.initMeetingResolutionMercure();
  },
  beforeDestroy() {
    eventSource.close();
  },
  methods: {
    initMeetingResolutionMercure() {
      if (eventSource) eventSource.close();
      const topics = [`${meetingResolutionIRI}{id}`, `${resolutionVoteIRI}{id}`];
      eventSource = helperFunctions.getEventSource(topics);
      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(meetingResolutionIRI)) {
          model = meetingResolutionModel;
        } else if (eventData["@id"].includes(resolutionVoteIRI)) {
          model = resolutionVoteModel;
        }
        helperFunctions.modifyInStore(eventData, model, eventData["@type"]);
      };

      helperFunctions.case401Error(eventSource);
    },
  },
};
